import {Navigate, useParams} from 'react-router-dom'

/** Se conserva como redirección a «Perfil de empresa» para que los enlaces viejos no den 404. */
export function PerfilRiesgoPage() {
  const {businessId} = useParams()
  return <Navigate to={`/businesses/${businessId}/profile`} replace />
}
